import propTypes from 'prop-types';
import { useTheme } from 'styled-components';

const SvgPorterLogo = ({ size, color, ...props }) => {
  const theme = useTheme();

  return (
    <svg
      width={size}
      height={(size * 40) / 136}
      viewBox="0 0 136 40"
      fill={theme.colors[color] || color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_295_183)">
        <path
          d="M59.6741 18.2354C59.6741 20.9757 57.5386 22.35 54.3251 22.35H49.585V25.8804H46.1575V14.1166H54.3281C57.5386 14.1166 59.6741 15.528 59.6741 18.2354ZM56.1941 18.3022C56.1941 17.109 55.3198 16.7222 54.0422 16.7222H49.585V19.8658H54.0401C55.3198 19.8658 56.1941 19.4821 56.1941 18.3022Z"
          fill="inherit"
        />
        <path
          d="M60.464 19.9964C60.464 16.0114 63.4728 13.7216 68.1295 13.7216C72.7863 13.7216 75.8156 16.0155 75.8156 19.9964C75.8156 23.9773 72.7893 26.2712 68.1326 26.2712C63.4759 26.2712 60.464 23.9845 60.464 19.9964ZM72.3182 19.9964C72.3182 17.7766 70.7207 16.5165 68.1316 16.5165C65.56 16.5165 63.946 17.7766 63.946 19.9964C63.946 22.2162 65.5425 23.4764 68.1316 23.4764C70.7207 23.4764 72.3182 22.2193 72.3182 19.9964Z"
          fill="inherit"
        />
        <path
          d="M87.5424 25.8845L84.4328 22.169H80.9734V25.8845H77.5644V14.1166H85.8194C88.8282 14.1166 91.1684 15.4446 91.1684 18.1346C91.1684 20.1014 89.9237 21.345 88.0752 21.883L91.5377 25.8845H87.5424ZM85.5591 19.6806C86.7863 19.6806 87.6772 19.3443 87.6772 18.2014C87.6772 17.0586 86.7863 16.7222 85.5591 16.7222H80.959V19.6806H85.5591Z"
          fill="inherit"
        />
        <path
          d="M104.812 16.857H99.9192V25.8845H96.4917V16.857H91.6313V14.1166H104.812V16.857Z"
          fill="inherit"
        />
        <path
          d="M118.663 23.2614V25.8845H106.106V14.1166H118.479V16.7387H109.485V18.6726H116.898V21.1773H109.485V23.2614H118.663Z"
          fill="inherit"
        />
        <path
          d="M130.381 25.8845L127.271 22.169H123.808V25.8845H120.395V14.1166H128.65C131.658 14.1166 133.999 15.4446 133.999 18.1346C133.999 20.1014 132.754 21.345 130.906 21.883L134.368 25.8845H130.381ZM128.398 19.6806C129.625 19.6806 130.516 19.3443 130.516 18.2014C130.516 17.0586 129.625 16.7222 128.398 16.7222H123.791V19.6806H128.398Z"
          fill="inherit"
        />
        <path
          d="M18.2839 7.86751L27.7691 13.3441L18.2839 18.8207L15.9118 17.4515L8.79756 13.3441L18.2839 7.86751ZM7.7761 15.1134V26.0655L17.2624 31.5421V20.59L14.8903 19.2208L7.7761 15.1134ZM36.0221 11.8114V28.1887C36.0221 28.8128 35.8577 29.426 35.5455 29.9664C35.2332 30.5069 34.7842 30.9556 34.2435 31.2674L20.0624 39.4556C19.5219 39.7679 18.9086 39.9323 18.2844 39.9323C17.6601 39.9323 17.0469 39.7679 16.5063 39.4556L2.32318 31.2674C1.78274 30.9554 1.33396 30.5066 1.02194 29.9662C0.709915 29.4257 0.545651 28.8127 0.545654 28.1887V11.8114C0.54586 11.1874 0.710211 10.5744 1.02221 10.034C1.33421 9.49361 1.78288 9.04479 2.32318 8.73261L16.5053 0.544491C17.0458 0.232179 17.6591 0.067749 18.2833 0.067749C18.9076 0.067749 19.5209 0.232179 20.0614 0.544491L34.2435 8.73261C34.7841 9.04458 35.233 9.49333 35.5452 10.0338C35.8574 10.5742 36.0219 11.1873 36.0221 11.8114ZM30.8335 13.3441C30.8332 13.1644 30.7856 12.988 30.6952 12.8326C30.6049 12.6773 30.4752 12.5486 30.3192 12.4594L18.7941 5.80093C18.6389 5.71098 18.4627 5.66361 18.2833 5.66361C18.104 5.66361 17.9278 5.71098 17.7726 5.80093L6.24443 12.4564C6.08854 12.5456 5.95893 12.6744 5.86863 12.8297C5.77834 12.985 5.73056 13.1614 5.7301 13.341V26.656C5.73035 26.8356 5.77804 27.0121 5.86836 27.1674C5.95867 27.3227 6.0884 27.4515 6.24443 27.5406L17.7726 34.1919C17.9279 34.2813 18.1039 34.3284 18.2831 34.3283C18.4623 34.3283 18.6383 34.2811 18.7935 34.1916C18.9487 34.1021 19.0777 33.9734 19.1675 33.8184C19.2574 33.6634 19.3049 33.4875 19.3053 33.3083V20.59L30.3223 14.2287C30.4778 14.1393 30.6069 14.0104 30.6967 13.8551C30.7865 13.6998 30.8337 13.5235 30.8335 13.3441Z"
          fill="inherit"
        />
      </g>
      <defs>
        <clipPath id="clip0_295_183">
          <rect
            width="135"
            height="40"
            fill="white"
            transform="translate(0.477478)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

SvgPorterLogo.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
};

SvgPorterLogo.defaultProps = {
  size: 68,
  color: 'white',
};

export default SvgPorterLogo;
